export default __webpack_public_path__ + "static/media/LogoVlecvi.28bace76.png";